<ng-content select="list-search-box"></ng-content>
<div
  style="background-color: #f3e8d1; flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column"
  *ngIf="items && dataLoaded"
>
  <div class="row">
    <div
      *ngIf="items.paging && options.showPaging !== false && (!options.pager || options.pager.bottom)"
    >
      <div class="col-md-12">
        <pager
          [items]="items.paging"
          (pageChanged)="pageChanged($event)"
          [options]="(options.pager && options.pager.bottom) || { showPagingSummary:true }"
        ></pager>
      </div>
    </div>
  </div>
  <br />
  <br />
  <ng-content
    *ngIf="items.length || options.renderEmpty"
    select="list-render-items"
    style="flex: 1 1 auto; min-height: 0"
  ></ng-content>
  <h3 *ngIf="!items.length" class="text-danger">No items were found using the filter criteria</h3>
</div>
